import { render, staticRenderFns } from "./InventoryStatus.vue?vue&type=template&id=7b454e23"
import script from "./InventoryStatus.vue?vue&type=script&lang=js"
export * from "./InventoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports